import React from 'react';
import { MultiStepModalContext } from './modal.context';

export type MultiStepModalProviderProps = React.PropsWithChildren<{
  disableCloseOnOverlayClick?: boolean;
  disableCloseOnEscape?: boolean;
  onChangeDisableOverlayClick?: (disable: boolean) => void;
  onChangeDisableEscape?: (disable: boolean) => void;
  closeModal: () => void;
}>;

export function MultiStepModalProvider({
  children,
  disableCloseOnOverlayClick: disableClickControl = false,
  disableCloseOnEscape: disableEscapeControl = false,
  onChangeDisableOverlayClick,
  onChangeDisableEscape,
  closeModal,
}: MultiStepModalProviderProps) {
  const [disableClickInternal, setDisableClickInternal] = React.useState(disableClickControl);
  const [disableEscapeInternal, setDisableEscapeInternal] = React.useState(disableEscapeControl);

  const disableCloseOnOverlayClick = React.useMemo(() => {
    return typeof disableClickControl === 'boolean' ? disableClickControl : disableClickInternal;
  }, [disableClickControl, disableClickInternal]);

  const disableCloseOnEscape = React.useMemo(() => {
    return typeof disableEscapeControl === 'boolean' ? disableEscapeControl : disableEscapeInternal;
  }, [disableEscapeControl, disableEscapeInternal]);

  const setDisableCloseOnOverlayClick = React.useCallback(() => {
    if (typeof disableClickControl === 'boolean') {
      onChangeDisableOverlayClick?.(disableClickControl);
    } else {
      setDisableClickInternal((prev) => !prev);
    }
  }, [setDisableClickInternal]);

  const setDisableCloseOnEscape = React.useCallback(() => {
    if (typeof disableEscapeControl === 'boolean') {
      onChangeDisableEscape?.(disableEscapeControl);
    } else {
      setDisableEscapeInternal((prev) => !prev);
    }
  }, [setDisableEscapeInternal]);

  const value = {
    disableCloseOnOverlayClick,
    disableCloseOnEscape,
    setDisableCloseOnOverlayClick,
    setDisableCloseOnEscape,
    closeModal,
  };

  return <MultiStepModalContext.Provider value={value}>{children}</MultiStepModalContext.Provider>;
}
